<template>
  <div class="relative w-full h-screen bg-[#1b183f] text-white font-sans">
    <div class="absolute top-0 left-0 w-full h-[5px] bg-white/10">
      <div class="h-full bg-yellow-300 transition-all duration-300" :style="{ width: progressBarWidth }"></div>
    </div>

    <transition name="fade" mode="out-in">
      <!-- Section 1 -->
      <section v-if="currentSection === 1" key="1"
        class="flex flex-col items-center justify-center h-full px-4 text-center">
        <div class="mb-6">
          <img :src="whiteLogo" alt="Center logo" class="w-auto h-16" />
        </div>
        <div class="space-y-6">
          <h1 class="text-4xl font-bold">Help Us Get to Know You Better!</h1>
          <h3 class="text-xl text-gray-400 font-medium">
            To make our discussion as insightful and tailored as possible, we’d
            love to learn more about your company. Could you share some details
            with us?
          </h3>
        </div>
        <button @click="goNext"
          class="mt-8 px-6 py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
          Start
        </button>
      </section>

      <section v-else :key="currentSection" class="flex flex-col items-center justify-center h-full px-4">
        <!-- <button @click="goPrev"
          class="absolute top-5 left-5 flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white text-sm sm:text-base px-3 py-2 rounded-full shadow-md transition-all duration-200">
          <span class="material-symbols-rounded text-lg sm:text-xl px-8">
            Back
          </span>
        </button> -->

        <div class="w-full max-w-md space-y-6">
          <!-- Section 10 -->
          <div v-if="currentSection === 10" class="space-y-6 text-center">
            <img src="@/assets/new/thankyou.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h3 class="text-xl text-gray-400 font-medium">
              Your inside sales team is looking to increase efficiency and
              productivity. Could you share some details about to manage their sales pipeline and
              customer relationships connction soon !
            </h3>
            <button
              class="w-[250px] py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Back To Home
            </button>
          </div>
          <!-- Section 9 -->
          <div v-else-if="currentSection === 9" class="space-y-6 text-center">
            <img src="@/assets/new/img2.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">Processes You`d Like To Enhance ? </h2>
            <input v-model="formData[10]" type="text"
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
              placeholder="E.g. Order Processing System" required />
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>
          <!-- Section 8 -->
          <div v-else-if="currentSection === 8" class="space-y-6 text-center">
            <img src="@/assets/new/img7.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">Tools You`re Using Now ? </h2>
            <input v-model="formData[9]" type="text"
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
              placeholder="E.g. CRM System,HRMS System" required />
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>
          <!-- Section 7 -->
          <div v-else-if="currentSection === 7" class="space-y-6 text-center">
            <img src="@/assets/new/img6.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">What You Aim to Achieve With Galecta ? </h2>
            <input v-model="formData[8]" type="text"
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
              placeholder="E.g. Improve Productivity, Increase Efficiency" required />
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>
          <!-- Section 6 -->
          <div v-else-if="currentSection === 6" class="space-y-6 text-center">
            <img src="@/assets/new/img5.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">Your Key Obstacle ?</h2>
            <input v-model="formData[7]" type="text"
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
              placeholder="E.g. Workflow Efficiency, Employee Management" required />
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>
          <!-- Section 5 -->
          <div v-else-if="currentSection === 5" class="space-y-6 text-center">
            <img src="@/assets/new/img4.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">Size Of Your Team?</h2>

            <select v-model="formData[6]" required
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400">
              <option disabled value="">Select team size</option>
              <option>1-10</option>
              <option>11-25</option>
              <option>26-50</option>
              <option>51-100</option>
              <option>101-250</option>
              <option>250+</option>
            </select>
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>

          <!-- Section 4 -->
          <div v-else-if="currentSection === 4" class="space-y-6 text-center">
            <img src="@/assets/new/img3.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">The Sector You operate In ?</h2>
            <input v-model="formData[5]" type="text"
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
              placeholder="E.g. Healthcare" required />
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>
          <!-- Section 3 -->
          <div v-else-if="currentSection === 3" class="space-y-6 text-center">
            <img src="@/assets/new/img2.jpg" alt="Office" class="rounded-2xl w-full object-cover h-56" />
            <h2 class="text-lg sm:text-xl font-medium">What's Your Company Called?</h2>
            <input v-model="formData[4]" type="text"
              class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
              placeholder="E.g. ABC Corp" required />
            <button @click="goNext"
              class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
              Next
            </button>
          </div>

          <!-- Section 2 -->
          <div v-else-if="currentSection === 2" class="space-y-4">
            <img :src="whiteLogo" alt="Logo" class="h-24 mx-auto" />
            <h2 class="text-xl sm:text-2xl font-semibold text-center">
              {{ sectionTitles[currentSection - 2] }}
            </h2>
            <form @submit.prevent="goNext" class="space-y-4">
              <div class="flex flex-col space-y-2">
                <!-- <label class="font-semibold text-sm sm:text-base">Full Name</label> -->
                <input v-model="formData[1]" type="text"
                  class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
                  placeholder="Eg. John Doe" required />
              </div>

              <div class="flex flex-col sm:flex-row gap-4">
                <div class="flex flex-col w-full sm:w-1/2 space-y-2">
                  <label class="font-semibold text-lg sm:text-base">Write to ?</label>
                  <input v-model="formData[2]" type="email"
                    class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
                    placeholder="Eg. john@example.com" required />
                </div>
                <div class="flex flex-col w-full sm:w-1/2 space-y-2">
                  <label class="font-semibold text-lg sm:text-base">Job Role ?</label>
                  <input v-model="formData[3]" type="text"
                    class="w-full px-4 py-3 bg-white/10 border border-gray-500 rounded text-white placeholder:text-gray-400 focus:outline-none focus:border-yellow-400"
                    placeholder="Eg. CEO" required />
                </div>
              </div>
              <button type="submit"
                class="w-full py-3 bg-yellow-400 text-black rounded hover:bg-yellow-500 text-lg transition-all duration-200">
                Next
              </button>
            </form>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import whiteLogo from '@/assets/newd/white_logo.svg';

export default {
  data() {
    return {
      currentSection: 1,
      totalSections: 10,
      formData: Array(10).fill(''),
      sectionTitles: [
        'Introduce Yourself!',
        'Company Info',
        'Business Goals',
        'Challenges Faced',
        'Solutions Sought',
        'Tech Stack',
        'Team Structure',
        'Timeframe Expectations',
      ],
      whiteLogo,
    };
  },
  computed: {
    progressBarWidth() {
      return `${(this.currentSection / this.totalSections) * 100}%`;
    },
  },
  methods: {
    goNext() {
      if (this.currentSection < this.totalSections) {
        this.currentSection++;
      } else {
        alert('Form submitted!');
        console.log(this.formData);
      }
    },
    goPrev() {
      if (this.currentSection > 1) {
        this.currentSection--;
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>